(function (d) {
  // Accordions
  const faqs = d.querySelectorAll('.lnb-faq');
  if (!faqs) return;

  const toggleFaq = (faq) => {
    const answer = faq.querySelector('.lnb-faq__answer');
    if (faq.classList.contains('lnb-faq--open')) {
      answer.style.height = null;
      return faq.classList.remove('lnb-faq--open');
    }
    answer.style.height = `${answer.scrollHeight}px`;
    return faq.classList.add('lnb-faq--open');
  };

  faqs.forEach((faq) => {
    const controller = faq.querySelector('.lnb-faq__question');
    controller.addEventListener('click', (e) => {
      toggleFaq(faq);
    });
  });

  // Scroll the brothers
  const controllers = d.querySelectorAll('.lnb-faq-container__controller');
  if (!controllers) return;

  controllers.forEach((controller) => {
    controller.addEventListener('click', (e) => {
      const matchingBlock = d.querySelector(`div[data-category="${controller.dataset.category}"]`);
      const y = matchingBlock.getBoundingClientRect().top + window.pageYOffset - 125;
      window.scrollTo({
        top: y,
        behavior: 'smooth',
      });
    });
  });
})(document);
